class SecurityTabs {
  constructor(element) {
    this.element = element
    this.bindEvents()
  }

  bindEvents() {
    const tabs = this.element.querySelectorAll(`[role="tab"]`)
    const tabList = this.element.querySelector(`[role="tablist"]`)

    let tabFocus = 0

    tabs.forEach(tab => {
      tab.addEventListener("click", ev => {
        this.changeTabs(ev)
      })
    })

    tabList.addEventListener("keydown", ev => {
      // Right or left key press
      if (ev.keyCode === 39 || ev.keyCode === 37) {
        tabs[tabFocus].setAttribute("tabindex", -1)

        // Right key press
        if (ev.keyCode === 39) {
          tabFocus++

          if (tabFocus >= tabs.length) {
            tabFocus = 0
          }
        } else if (ev.keyCode === 37) {
          // Left key press
          tabFocus--

          if (tabFocus < 0) {
            tabFocus = tabs.length - 1
          }
        }

        tabs[tabFocus].setAttribute("tabindex", 0)
        tabs[tabFocus].focus()
      }
    })
  }

  changeTabs(ev) {
    const target = ev.target
    const tabButtons = this.element.querySelectorAll(`[role="tab"]`)

    tabButtons.forEach(t => t.setAttribute("aria-selected", false))

    target.setAttribute("aria-selected", true)

    this.element.querySelectorAll(`[role="tabpanel"]`).forEach(p => p.setAttribute("hidden", true))
    this.element.querySelector(`#${target.getAttribute("aria-controls")}`).removeAttribute("hidden")
  }
}

export default function init() {
  const el = document.querySelector(".security-tabs")

  if (el) {
    new SecurityTabs(el)
  }
}
